// ProjectManagerCell Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import RowCellBase from '../../../../components/ListCell/CellContainer.jsx'

// TODO: dont override CellContainer - refactor this component render instead
const CellContainer = styled(RowCellBase)`
  padding: 0;
`

class ProjectManagerCell extends Component {
  static get propTypes () {
    return {
      info: PropTypes.object,
      width: PropTypes.string,
      onView: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      info: null,
      width: null,
      onView: null
    }
  }

  render () {
    const { info, onView, width } = this.props

    return (
      <CellContainer width={width} className='project-managercell list-cell'>
        <div className='listrowcell pmcell'>
          <div className='cont'>
            <div className='contleft'>
              <div className='pmcont' onClick={onView}>
                <div className='pmtitle'>{info.name ? info.name : '-'}</div>
              </div>
            </div>
          </div>
        </div>
      </CellContainer>
    )
  }
}

export default ProjectManagerCell
